












import { Component, Vue, Watch } from "vue-property-decorator";

import ErrorModule from "../store/modules/errorModule";
import { getModule } from "vuex-module-decorators";

const errorStore = getModule(ErrorModule);

@Component({
  components: {}
})
export default class ErrorAlert extends Vue {
  @Watch("error") private onError() {
    if (this.error !== "") {
      this.dismissCountDown = this.dismissSecs;
    }
  }

  private dismissSecs = 10;
  private dismissCountDown = 0;
  private errorMessage = "";

  private get error() {
    return errorStore.error;
  }

  private countDownChanged(dismissCountDown: number) {
    this.dismissCountDown = dismissCountDown;
  }

  private dismissed() {
    this.dismissCountDown = 0;
    errorStore.set("");
  }
}
